import { useCallback } from "react";
import { useNavigate } from "react-router";
import { MaxSearchResultCount, universalSearchResultItem, useUniversalSearch } from "Shared/UniversalSearch";
import { useORPCClient } from "Core/oRPC";
import { AppRegistry } from "Apps/AppRegistry";

export const useRuntimeInsightsUniversalSearch = () => {
    const navigate = useNavigate();
    const { shasApi } = useORPCClient();

    const searchRuntimeInsights = useCallback(
        async (searchText: string) => {
            if (!searchText) {
                return [];
            }

            const resultList: universalSearchResultItem[] = [];

            try {
                const employees = await shasApi.getSearchEmployee({ searchString: searchText });

                employees.slice(0, MaxSearchResultCount).forEach((employee) => {
                    if (employee.Id) {
                        resultList.push({
                            id: employee.Id,
                            title: employee.FullName || employee.Id,
                            description: employee.Id,
                            onClick: () => {
                                navigate(`/RuntimeInsights?Employee=${employee.Id}`);
                            },
                            navigationTarget: `/RuntimeInsights?Employee=${employee.Id}`
                        });
                    }
                });

                return resultList;
            } catch (error) {
                return resultList;
            }
        },
        // eslint-disable-next-line react-hooks/exhaustive-deps
        [navigate]
    );

    const { searchWord } = useUniversalSearch("RuntimeInsights", "employees", searchRuntimeInsights, false, AppRegistry.RuntimeInsights.path);
    return { searchWord };
};
